import React, {Component} from "react";
import HomeSlider from "../HomeSlider/HomeSlider";

import styles from "./HomeContent.module.scss";
import RightPicture from "../Section/RightPicture";
import pictureMethodo from "./img/references.jpg";


class HomeContent extends Component {
    render() {


        let smalltitle = "Découvrez";
        let titlemethodo = "Nos réalisations";
        let descriptionmethodo = [
            "Nous accompagnons tous nos clients afin de mener à bien leurs projets, en répondant à leurs besoins, leurs contraintes et leurs gouts !", <br />, <br />, "N'hésitez pas à venir découvrir nos dernières réalisations !",
            <div className={`${styles.fh5cobtnaction} fh5co-btn-action animate-box row-top-padded-md`}>
                <a href="/realisation" className="btn btn-primary btn-cta">Découvrir ...</a>
            </div>
        ];
        let altmethodo = "Méthodologie agile Scrum en image";
        let picturemethodo = pictureMethodo;
        return (
            <div>
                <section className={`row-top-padded-lg ${styles.fh5cofeatures}`}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className={styles.fh5cofeature}>
                                    <div className={styles.fh5coicon}><i className="icon-equalizer2"/></div>
                                    <h3>Conseil</h3>
                                    <p>Nous vous apportons notre expertise dans le milieu du Web pour vous conseiller dans la réalisation de vos projets.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className={styles.fh5cofeature}>
                                    <div className={styles.fh5coicon}><i className="icon-embed2"/></div>
                                    <h3>Réalisation</h3>
                                    <p>Nous développons des applications web à l'aide de technologies récentes et éprouvées. Notre processus de développement vous assure une réalisation de qualité.</p>
                                </div>
                            </div>
                            <div className="clearfix d-block d-md-none-block"/>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className={styles.fh5cofeature}>
                                    <div className={styles.fh5coicon}><i className="icon-loop"/></div>
                                    <h3>Méthode agile</h3>
                                    <p>Tous les projets vivent des évolutions pendant leurs réalisations, c'est pourquoi nous travaillons avec une méthode Agile (Scrum) qui nous permet de recentrer vos besoins.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className={styles.fh5cofeature}>
                                    <div className={styles.fh5coicon}><i className="icon-rocket"/></div>
                                    <h3>Technologies</h3>
                                    <p>Nous analysons votre projet pour proposer la ou les technologies les plus adaptées à sa réalisation. Haute volumétrie, Fort trafic, nous utilisons des langages et des applications reconnues.</p>
                                </div>
                            </div>
                            <div className="clearfix d-block d-md-none-block"/>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className={styles.fh5cofeature}>
                                    <div className={styles.fh5coicon}><i className="icon-bubbles4"/></div>
                                    <h3>Communication</h3>
                                    <p>La communication est essentielle pour fournir une solution de qualité. C'est pourquoi tous nos projets sont composés de points d'avancement et tests réguliers.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 animate-box row-bottom-padded-lg">
                                <div className={styles.fh5cofeature}>
                                    <div className={styles.fh5coicon}><i className="icon-git"/></div>
                                    <h3>Qualité et sécurité</h3>
                                    <p>Tous nos projets sont réalisés à l'aide de tests unitaires et fonctionnels automatisés, de tests de qualité du code, qui garantissent un développement de qualité.</p>
                                </div>
                            </div>
                            <div className="clearfix d-block d-md-none-block"/>
                        </div>
                    </div>
                </section>
                <section className={`row-bottom-padded-lg row-top-padded-lg ${styles.fh5cofeatures2}`}>
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-6">
                                <span className="fh5co-label animate-box">Développement Web</span>
                                <h2 className="fh5co-lead animate-box">Des technologies reconnues</h2>
                                <div className={styles.fh5cofeature}>
                                    <div className={`${styles.fh5coicon} animate-box`}><i className="icon-checkmark"/>
                                    </div>
                                    <div className={`${styles.fh5cotext} animate-box`}><h3>Open Source</h3>
                                        <p>Nous utilisons majoritairement des <strong>technologies web Open-source</strong> dont leurs efficacités n'est plus à prouver.
                                        </p></div>
                                </div>
                                <div className={styles.fh5cofeature}>
                                    <div className={`${styles.fh5coicon} animate-box`}><i className="icon-checkmark"/>
                                    </div>
                                    <div className={`${styles.fh5cotext} animate-box`}><h3>Volumétrie et trafic</h3>
                                        <p>En fonction de votre besoin, nous déployons des <strong>applications scalables et Cloud Ready</strong> pour répondre à une forte demande et à une forte volumétrie.
                                        </p></div>
                                </div>
                                <div className={styles.fh5cofeature}>
                                    <div className={`${styles.fh5coicon} animate-box`}><i className="icon-checkmark"/>
                                    </div>
                                    <div className={`${styles.fh5cotext} animate-box`}><h3>Architecture technique</h3>
                                        <p>A chaque projet son infrastructure. C'est pourquoi nous proposons des <strong>architectures robustes et sécurisées</strong>, qui respectent votre système d'information, pour l'ensemble de vos projets
                                        </p></div>
                                </div>
                                <div className={`${styles.fh5cobtnaction} fh5co-btn-action animate-box`}>
                                    <a href="/technologies-web" className="btn btn-primary btn-cta">En savoir plus</a>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <figure className={`${styles.fh5cofeatureimage} animate-box`}>
                                    <img src="images/macbook.png" alt="Liste des logo des technologies utilisées"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </section>
                <RightPicture smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />

            </div>

        );
    }
}

export default HomeContent;



// WEBPACK FOOTER //
// ./src/components/HomeContent/HomeContent.jsx